import ToolsetSelection from "./toolset.selection";
import styles from './stack.module.scss';
import useUserDetails from "../../hooks/user-details.hook";
import { useEffect, useState } from "react";
import ContentLoader from "react-content-loader";
import { useEntity } from "../../hooks/use-entity.hook";
import { Entities } from "../../common/store/entities/entities.enum";
import useActions from "../../hooks/service-actions.hook";
import { SecurityStackViewEffectActions } from "../../common/services/security-stack-view/security-stack-view.service";
import cn from "../../Utils/class-names.utils";
import ToolsPracticesModalsContainer from "./tools-practices-modals.container";

const StackPage = () => {
  const { clientId } = useUserDetails();
  const [toolData, setToolData] = useState([]);
  const [mainPageLoading, setMainPageLoading] = useState(false);
  const { entityData: securityStackViewData } = useEntity({ entityType: Entities.SecurityStackView, entityId: clientId });
  const { getSecurityStackView } = useActions(SecurityStackViewEffectActions);

  function getPageData(kwargs = {}) {
    getSecurityStackView({ clientId });
    return new Promise((resolve) => resolve());
  }

  const refreshTechToolData = () => {
    getPageData();
  }

  useEffect(() => {
    setMainPageLoading(true);
    getPageData();
  }, []);

  useEffect(() => {
    if (!securityStackViewData) return;
    setMainPageLoading(false);
    let tool_data = [
      ...securityStackViewData?.CDSAMainMenuOption_List[0]?.ToolAttestationRow_List,
    ];

    let updated_tool_data = tool_data?.map((toolData, toolIndex) => {
      let updated_integrationList = toolData?.IntegrationList?.filter(
        (item) => item?.IntegrationId > 0
      ).map((toolIntegration, toolIntegrationIndex) => {
        return { ...toolIntegration, loading: false };
      });

      return {
        ...toolData,
        IntegrationList: updated_integrationList,
        addNewTool: false,
        newToolName: "",
        addingNewTool: false,
        newToolSelected: false,
        loading: false,
        selected:
          toolData?.SelectedTool_List?.length > 0
            ? { id: 1, category: "Yes" }
            : toolData?.ShowNoCapability
              ? { id: 0, category: "No" }
              : null,
        dummy_SelectedTool_List:
          toolData?.SelectedTool_List?.length > 0
            ? [...toolData?.SelectedTool_List]
            : [],
      };
    });

    setToolData(updated_tool_data);
  }, [securityStackViewData]);
  
  return (
    <div className={cn(styles.page, 'security-stack-wrapper')}>
      {mainPageLoading ? (
        <SecurityStackLoader />
      ) : (
        <div className="d-flex flex-column gap-24">
          <h2 className="m-0 f-14 f-black f-600">My MSP toolset</h2>
          <ToolsetSelection 
            clientId={clientId}
            toolData={toolData}
            searchMspTools={""}
            setOpenTool={() => {}}
            refreshIntegrsInfo={() => {}}
            refreshTechToolData={refreshTechToolData}
          />
        </div>
      )}
      <ToolsPracticesModalsContainer clientId={clientId} refreshData={refreshTechToolData} isView={true} />
    </div>
  )
}

export default StackPage;

const SecurityStackLoader = () => {
  return (
    <ContentLoader
      speed={2}
      width={"100%"}
      height={"100%"}
      viewBox="0 0 1500 900"
      backgroundColor="#F6F8FB"
      foregroundColor="#ecebeb"
    >
      <rect x="0%" y="70" rx="8" ry="8" width="100%" height="140" />
      <rect x="0%" y="212" rx="8" ry="8" width="100%" height="140" />
      <rect x="0%" y="354" rx="8" ry="8" width="100%" height="140" />
      <rect x="0%" y="496" rx="8" ry="8" width="100%" height="140" />
      <rect x="0%" y="638" rx="8" ry="8" width="100%" height="140" />
      <rect x="0%" y="780" rx="8" ry="8" width="100%" height="140" />
      <rect x="0%" y="922" rx="8" ry="8" width="100%" height="140" />
    </ContentLoader>
  );
};
